import React from 'react';

import type { AiChatReference } from '~/components/AiChat/types';
import CardDialog from '~/components/CardDialog';
import { useClaim } from '~/components/ClaimContainer';
import { LoadingSwitch } from '~/components/core';
import NoteMiniCard from '~/components/Notes/NoteMiniCard';
import type { Note } from '~/components/Notes/types';
import type { ClaimPolymorph } from '~/components/types/claim-types';
import useDataFetcher from '~/components/useDataFetcher';

interface NoteReferenceDialogProps {
  noteReference: AiChatReference;
  onClose: () => void;
  claimId: ClaimPolymorph['id'];
}

export const NoteReferenceDialog: React.FC<NoteReferenceDialogProps> = ({ noteReference, onClose, claimId }) => {
  const { claim } = useClaim({ claimRequired: true });
  const {
    data: note,
    isLoading,
    reloadData,
    isError,
  } = useDataFetcher<Note>(`/api/v1/claims/${claimId}/notes/${noteReference?.id}`);

  return (
    <CardDialog open={true} onClose={onClose} isDialog noCardTitle>
      <LoadingSwitch isLoading={isLoading} isError={isError}>
        {note && (
          <NoteMiniCard
            note={note}
            claim={claim}
            onNoteUpdate={async () => {
              await reloadData();
            }}
          />
        )}
      </LoadingSwitch>
    </CardDialog>
  );
};
